import React from 'react';

import { Icon } from '@column/column-ui-kit';
import { cn } from '@column/ui';

// Darker steps than the 500s for contrast on white: green reaches 3:1, while yellow stays brighter (1.7:1) so it
// doesn't turn muddy. Dark mode keeps the 500s.

interface AccessIconProps {
  className?: string;
}

export const AccessIconDefault: React.FC<AccessIconProps> = ({ className }) => (
  <Icon.Settings className={cn('text-gray-400 dark:text-gray-500', className)} />
);

export const AccessIconNoAccess: React.FC<AccessIconProps> = ({ className }) => (
  <Icon.Close className={cn('text-red-500 dark:text-red-400', className)} />
);

export const AccessIconViewOnly: React.FC<AccessIconProps> = ({ className }) => (
  <Icon.Eye className={cn('text-primary dark:text-blue-400', className)} />
);

export const AccessIconEdit: React.FC<AccessIconProps> = ({ className }) => (
  <Icon.Edit className={cn('text-yellow-600 dark:text-yellow-500', className)} />
);

export const AccessIconFullAccess: React.FC<AccessIconProps> = ({ className }) => (
  <Icon.CircleCheck className={cn('text-seafoam-650 dark:text-seafoam-500', className)} />
);

export const AccessIconCustom: React.FC<AccessIconProps> = ({ className }) => (
  <Icon.Filters className={cn('text-yellow-600 dark:text-yellow-500', className)} />
);
